<template>
  <li
    class="p-3 email-row"
  >
    <div class="email-cell">
      <b-button
        v-if="context === 'group'"
        variant="link"
        class="expand-toggle p-0 mr-2"
        :data-test="`expand-campaigns-${index}`"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="toggleExpand"
      >
        <i :class="expanded ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'" />
      </b-button>
      <span class="email-text">{{ email }}</span>
    </div>
    <div class="checkboxes-cell">
      <div class="type-row">
        <span
          v-if="context === 'group'"
          class="count-badge"
        >
          {{ campaignTypeCount('CAMPAIGN') }}/{{ campaigns.length }}
        </span>
        <b-form-checkbox
          :data-test="`share-type-campaign-${index}`"
          :checked="currentTypes.includes('CAMPAIGN')"
          :indeterminate="isTypePartiallyChecked('CAMPAIGN')"
          @change="toggleType('CAMPAIGN', $event)"
        >
          Campaign
        </b-form-checkbox>
      </div>
      <div class="type-row">
        <span
          v-if="context === 'group'"
          class="count-badge"
        >
          {{ campaignTypeCount('SHOWCASE') }}/{{ campaigns.length }}
        </span>
        <b-form-checkbox
          :data-test="`share-type-creative-${index}`"
          :checked="currentTypes.includes('SHOWCASE')"
          :indeterminate="isTypePartiallyChecked('SHOWCASE')"
          :disabled="currentTypes.includes('CAMPAIGN')"
          @change="toggleType('SHOWCASE', $event)"
        >
          Creative
        </b-form-checkbox>
      </div>
      <div class="type-row">
        <span
          v-if="context === 'group'"
          class="count-badge"
        >
          {{ campaignTypeCount('REPORTING') }}/{{ campaigns.length }}
        </span>
        <b-form-checkbox
          :data-test="`share-type-reporting-${index}`"
          :checked="currentTypes.includes('REPORTING')"
          :indeterminate="isTypePartiallyChecked('REPORTING')"
          :disabled="currentTypes.includes('CAMPAIGN')"
          @change="toggleType('REPORTING', $event)"
        >
          Reporting
        </b-form-checkbox>
      </div>
    </div>
    <div class="actions-cell">
      <b-button
        v-if="resendEnabled && !isLinkActivated"
        size="sm"
        class="icon-button resend-button"
        @click="resend"
        title="Resend invite"
      >
        <i class="fa-regular fa-envelope" />
      </b-button>
      <span
        v-if="resendEnabled && isLinkActivated"
        class="link-activated-icon"
      >
        <i class="fa-solid fa-check" />
      </span>
      <b-button
        id="share-modal-email-delete"
        @click="showDeleteConfirmation()"
        data-test="creative-share-delete-btn"
        ref="share-email-input"
        size="sm"
        class="icon-button delete-button"
        title="Remove user"
      >
        <i class="fa-regular fa-trash-alt" />
      </b-button>
    </div>
    <div
      v-if="context === 'group' && expanded"
      class="campaign-subrows"
    >
      <p
        v-if="campaigns.length === 0"
        class="campaign-subrow-empty"
      >
        No campaigns in this group.
      </p>
      <table
        v-else
        class="campaign-permissions-table"
      >
        <thead>
          <tr>
            <th class="campaign-name-col" />
            <th>Campaign</th>
            <th>Creative</th>
            <th>Reporting</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="campaign in campaigns"
            :key="campaign.id"
          >
            <td
              class="campaign-name"
              :title="campaign.name"
            >
              {{ campaign.name }}
            </td>

            <td>
              <b-form-checkbox
                :data-test="`campaign-${campaign.id}-type-campaign-${index}`"
                :checked="campaignCurrentTypes(campaign.id).includes('CAMPAIGN')"
                @change="toggleCampaignType(campaign.id, 'CAMPAIGN', $event)"
              />
            </td>
            <td>
              <b-form-checkbox
                :data-test="`campaign-${campaign.id}-type-creative-${index}`"
                :checked="campaignCurrentTypes(campaign.id).includes('SHOWCASE')"
                :disabled="campaignCurrentTypes(campaign.id).includes('CAMPAIGN')"
                @change="toggleCampaignType(campaign.id, 'SHOWCASE', $event)"
              />
            </td>
            <td>
              <b-form-checkbox
                :data-test="`campaign-${campaign.id}-type-reporting-${index}`"
                :checked="campaignCurrentTypes(campaign.id).includes('REPORTING')"
                :disabled="campaignCurrentTypes(campaign.id).includes('CAMPAIGN')"
                @change="toggleCampaignType(campaign.id, 'REPORTING', $event)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal
      :id="`deleteEmailConfirmationModal${index}`"
      size="sm"
      centered
      title="Are you sure?"
      @ok="deleteEmail()"
    >
      <p
        class="my-1"
        style="word-break: break-word;"
      >
        Are you sure you want to remove<br>
        {{ email }}
      </p>
      <template
        #modal-footer="{ cancel, ok }"
      >
        <b-button
          size="md"
          variant="tertiary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="md"
          variant="primary"
          @click="ok()"
        >
          OK
        </b-button>
      </template>
    </b-modal>
  </li>
</template>
<script>

import { mapActions } from 'vuex';
import * as shareTypes from '@/modules/share/store/types';

export default {
  name: 'ShareModalEmailsListItem',
  props: {
    email: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    resendEnabled: {
      type: Boolean,
      default: false,
    },
    currentTypes: {
      type: Array,
      default: () => [],
    },
    context: {
      type: String,
      default: 'campaign',
    },
    campaignId: {
      type: Number,
      default: 0,
    },
    advertiserId: {
      type: Number,
      default: 0,
    },
    group: {
      type: String,
      default: '',
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    campaignPermissions: {
      type: Object,
      default: () => ({}),
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLinkActivated: false,
      expanded: this.isExpanded,
    };
  },
  methods: {
    ...mapActions('share', [
      shareTypes.RESEND_SHARE_WITH_EMAIL,
      shareTypes.RESEND_GROUP_SHARE,
    ]),
    toggleType(type, checked) {
      let next;
      if (checked) {
        // CAMPAIGN access encompasses Creative and Reporting, so checking it
        // auto-checks the other two as a one-time cascade. They remain freely
        // uncheckable afterwards (no lock), and unchecking CAMPAIGN does not
        // cascade back onto them.
        const additions = type === 'CAMPAIGN' ? [type, 'SHOWCASE', 'REPORTING'] : [type];
        next = [...new Set([...this.currentTypes, ...additions])];
      } else {
        next = this.currentTypes.filter((t) => t !== type);
      }
      this.$emit('update:currentTypes', next);

      // Every group-level checkbox additionally cascades down to every campaign in
      // the group: checking any type (Campaign, Creative, or Reporting) grants that
      // type to every campaign, and unchecking it revokes that type from every
      // campaign. For CAMPAIGN specifically, this still grants/revokes the full
      // Campaign + Creative + Reporting superset per campaign (same rule as the
      // same-row cascade above); Creative and Reporting only cascade their own
      // single type, without implying Campaign in either direction.
      if (this.context === 'group' && this.campaigns.length > 0) {
        const updatedPermissions = { ...this.campaignPermissions };
        this.campaigns.forEach((campaign) => {
          const existing = updatedPermissions[campaign.id] || { originalTypes: [], currentTypes: [] };
          let nextCampaignTypes;
          if (checked) {
            const additions = type === 'CAMPAIGN' ? [type, 'SHOWCASE', 'REPORTING'] : [type];
            nextCampaignTypes = [...new Set([...existing.currentTypes, ...additions])];
          } else {
            const removals = type === 'CAMPAIGN' ? ['CAMPAIGN', 'SHOWCASE', 'REPORTING'] : [type];
            nextCampaignTypes = existing.currentTypes.filter((t) => !removals.includes(t));
          }
          updatedPermissions[campaign.id] = { ...existing, currentTypes: nextCampaignTypes };
        });
        this.$emit('update:campaignPermissions', updatedPermissions);
      }
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    campaignCurrentTypes(campaignId) {
      const permission = this.campaignPermissions[campaignId];
      return (permission && permission.currentTypes) || [];
    },
    campaignTypeCount(type) {
      return this.campaigns.reduce((count, campaign) => (
        this.campaignCurrentTypes(campaign.id).includes(type) ? count + 1 : count
      ), 0);
    },
    // Shows a dash/indeterminate state on the group-level checkbox when some
    // (but not all, and not zero) campaigns in the group currently have this
    // type checked — e.g. campaign A has Reporting checked but campaign B does
    // not. This surfaces the "mixed" per-campaign state at a glance without
    // implying the group-level checkbox is fully checked or fully unchecked.
    isTypePartiallyChecked(type) {
      if (this.context !== 'group' || this.campaigns.length === 0) return false;
      const count = this.campaignTypeCount(type);
      return count > 0 && count < this.campaigns.length;
    },
    toggleCampaignType(campaignId, type, checked) {
      const current = this.campaignCurrentTypes(campaignId);
      let nextTypes;
      if (checked) {
        // Same CAMPAIGN → Creative/Reporting cascade as toggleType, applied to
        // this individual campaign's per-campaign permissions.
        const additions = type === 'CAMPAIGN' ? [type, 'SHOWCASE', 'REPORTING'] : [type];
        nextTypes = [...new Set([...current, ...additions])];
      } else {
        nextTypes = current.filter((t) => t !== type);
      }
      const existing = this.campaignPermissions[campaignId] || { originalTypes: [], currentTypes: [] };
      const updated = {
        ...this.campaignPermissions,
        [campaignId]: { ...existing, currentTypes: nextTypes },
      };
      this.$emit('update:campaignPermissions', updated);
    },
    showDeleteConfirmation() {
      this.$root.$emit('bv::show::modal', `deleteEmailConfirmationModal${this.index}`, '#share-email-input');
    },
    deleteEmail() {
      this.$emit('removeEmail', this.email);
    },
    resendToEmail() {
      // Resend the invite for each access type the sharee currently holds. In group
      // context `currentTypes` is the sharee's group-level types.
      if (this.context === 'group') {
        return Promise.all(
          this.currentTypes.map((type) => this.RESEND_GROUP_SHARE({
            advertiserId: this.advertiserId,
            group: this.group,
            body: { type, sharedWithEmails: [this.email] },
          })),
        );
      }
      return Promise.all(
        this.currentTypes.map((type) => this.RESEND_SHARE_WITH_EMAIL({
          campaignId: this.campaignId,
          body: { type, sharedWithEmails: [this.email] },
        })),
      );
    },
    async resend() {
      try {
        await this.resendToEmail();
        this.$emit('resendSuccess');
        this.isLinkActivated = true;
        setTimeout(() => {
          this.isLinkActivated = false;
        }, 30000);
      } catch (error) {
        this.$emit('apiError', error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.email-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 2rem;
  align-items: center;
}

.email-cell {
  word-break: break-word;
  display: flex;
  align-items: center;
}

.email-text {
  text-decoration: underline;
}

.expand-toggle {
  color: inherit;
  line-height: 1;

  i {
    font-size: 12px;
  }
}

.type-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  background-color: #e9f0fb;
  color: #4a5568;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1;
}

.campaign-subrows {
  grid-column: 1 / -1;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e9ecef;
}

.campaign-permissions-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #f7f8fa;
  border: 1px solid #e4e4e4;
  border-radius: 6px;

  thead th {
    text-align: center;
    font-size: 0.8rem;
    /* Muted grey column labels (not bold black) to match the design. */
    font-weight: 500;
    color: #8e94a0;
    padding: 0.5rem 0.75rem;
    /* No distinct header fill — the whole table shares one uniform background;
       only a thin divider separates the column labels from the rows. */
    border-bottom: 1px solid #e4e4e4;
  }

  thead th.campaign-name-col {
    text-align: left;
    width: 45%;
  }

  tbody td {
    padding: 0.5rem 0.75rem;
    text-align: center;
    vertical-align: middle;
  }

  tbody td.campaign-name {
    text-align: left;
  }

  /* Row separators between campaigns; last row is flush with the rounded edge. */
  tbody tr:not(:last-child) td {
    border-bottom: 1px solid #e4e4e4;
  }

  /* Sub-row checkboxes have no label text. Render the control as a fixed-size
     box that vertically centers within the (taller) campaign row. Bootstrap's
     .custom-control is inline and sits on the text baseline (dropping to the
     bottom in a tall row), so force it to a 1rem box aligned to the middle. */
  tbody td .custom-control {
    display: inline-block;
    vertical-align: middle;
    width: 1rem;
    height: 1rem;
    min-height: 0;
    padding: 0;
    margin: 0;
  }
}

/* Reposition bootstrap's absolutely-positioned checkbox box/checkmark so they
   fill the 1rem control above (defaults offset them by top:0.25rem/left:-1.5rem).
   ::v-deep is required because the label is rendered outside this component. */
::v-deep .campaign-permissions-table tbody td .custom-control-label::before,
::v-deep .campaign-permissions-table tbody td .custom-control-label::after {
  top: 0;
  left: 0;
}

.campaign-name {
  font-size: 0.875rem;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}


.campaign-subrow-empty {
  margin: 0;
  padding-left: 1.5rem;
  font-size: 0.875rem;
  color: #6c757d;
}

.checkboxes-cell {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

/*
 * QA fix: the tick (checked) and dash (indeterminate) icons on the
 * Campaign/Creative/Reporting checkboxes must use the brand colour
 * #2A51C7, matching in both the top-level rows and the per-campaign
 * sub-row table. ::v-deep is required because bootstrap-vue renders
 * .custom-control-input / .custom-control-label outside this
 * component's own markup.
 */
::v-deep .custom-control-input:checked ~ .custom-control-label::before,
::v-deep .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #2A51C7;
  border-color: #2A51C7;
}

::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after,
::v-deep .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-color: transparent;
}

/*
 * QA fix: disabled checkboxes (Creative/Reporting when Campaign is checked)
 * must still show a checked/ticked appearance in a muted version of the
 * brand colour, rather than falling back to bootstrap's default disabled
 * grey — so it's clear the value is "checked but locked", not "unchecked".
 */
::v-deep .custom-control-input:checked:disabled ~ .custom-control-label::before,
::v-deep .custom-control-input:indeterminate:disabled ~ .custom-control-label::before {
  background-color: rgba(42, 81, 199, 0.5);
  border-color: rgba(42, 81, 199, 0.5);
}

.actions-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}


.icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  i {
    font-size: 14px;
  }
}

.link-activated-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #28a745;
  font-size: 14px;
}

.resend-button {
  background-color: rgb(2, 186, 237);
  border-color: rgb(2, 186, 237);
  color: white;
  &:hover {
    background-color: rgb(1, 166, 213);
    border-color: rgb(1, 166, 213);
  }
}

.delete-button {
  background-color: rgb(255, 58, 108);
  border-color: rgb(255, 58, 108);
  color: white;
  &:hover {
    background-color: rgb(230, 52, 97);
    border-color: rgb(230, 52, 97);
  }
}
</style>
